import React, {useEffect, useState} from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import ObjectsGrid from "../../../components/accordion/ObjectsGrid";
import {jwtDecode} from "jwt-decode";
import DasboardServices from "../Services/DasboardServices";

const DashboardTablePage = () => {
    const token = localStorage.getItem("jwtToken");
    const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUserRole(decoded.role);
            } catch (error) {
                setUserRole("");
            } finally {
            }
        }
    }, [token]);

    return (
        <div className={"dashboard-page"}>
            {userRole && (
                <div className="dashboard-bggg">
                    <div className="dashboard-flex-containerr">
                        <Sidebar />
                        {userRole === "ROOTADMIN" ? (  <DasboardServices userRole = {"ROOTADMIN"} />) : (
                            <ObjectsGrid />
                        )}

                    </div>
                </div>
            )}
        </div>
    );
};

export default DashboardTablePage;
